import axios from 'axios'

export const checkBackendStatus = async () => {
  try {
    const baseUrl = process.env.REACT_APP_URL_BASE
    const response = await axios.get(`${baseUrl}/health`, { timeout: 5000 })
    if (response.status === 200 && response.data.status === 'ok') return 'backend-online'
    return 'backend-unhealthy'
  } catch (err) {
    if (!navigator.onLine) return 'offline'
    return 'backend-down'
  }
}
